module.exports = __webpack_public_path__ + "assets/copy-edit.5ea0cc7b.svg";